import { useEffect, useRef } from "react";
import { List } from "react-virtualized";
import {
  VIDEOS_PANEL_STOCK_FAKE_CELLS,
  VIDEOS_PANEL_STOCK_MASONRY_GAPS,
  VIDEOS_PANEL_STOCK_SKELETON_HEIGTS,
} from "../../constants";
import type { IStockVideo } from "../../types";
import { StockMasonryRow } from "./stock-masonry-row";

interface IProps {
  scrollTop: number;
  colWidth: number;
  height: number;
  videos: IStockVideo[];
  colIdx: number;
  onLoadMore?: () => void;
}

export const StockMasonryColumn = ({
  videos,
  scrollTop,
  colWidth,
  height,
  onLoadMore,
  colIdx,
}: IProps) => {
  const listRef = useRef<List | null>(null);

  useEffect(() => {
    if (!listRef.current) return;
    listRef.current.recomputeRowHeights();
  }, [colWidth, videos]);

  return (
    <List
      ref={listRef}
      onRowsRendered={
        onLoadMore
          ? (data) => {
              if (
                data.startIndex >=
                  videos.length - VIDEOS_PANEL_STOCK_FAKE_CELLS ||
                data.stopIndex >= videos.length - VIDEOS_PANEL_STOCK_FAKE_CELLS
              ) {
                onLoadMore();
              }
            }
          : undefined
      }
      autoHeight
      overscanRowCount={10}
      scrollTop={scrollTop}
      width={colWidth}
      height={height}
      rowCount={videos.length + VIDEOS_PANEL_STOCK_FAKE_CELLS}
      className="!tw-overflow-visible [&>div]:!tw-overflow-visible"
      rowHeight={({ index }) => {
        const data = videos[index];
        if (!data) {
          return (
            VIDEOS_PANEL_STOCK_SKELETON_HEIGTS[colIdx][index % 3] +
            VIDEOS_PANEL_STOCK_MASONRY_GAPS
          );
        }
        const height = colWidth * (data.height / data.width) || 67;
        return height + VIDEOS_PANEL_STOCK_MASONRY_GAPS;
      }}
      rowRenderer={(rowData) => (
        <StockMasonryRow
          key={rowData.key}
          rowData={rowData}
          videoData={videos[rowData.index]}
        />
      )}
    />
  );
};
